// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2St_1","name":"styles_name__1HHHa","phone":"styles_phone__1KO8-"};